//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#OVERLAY}\n\
 *\n\
 * @name czm_passOverlay\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passOverlay = 12.0;\n\
";
